import { FormatterFull } from "./FormatterFull";
import { IFormatter } from "./IFormatter";
import { ILogger } from "./ILogger";
import { IStream } from "./IStream";
import { Log } from "./Log";
import { LogLevel } from "./LogLevel";
import { StreamConsole } from "./StreamConsole";

export class Logger implements ILogger
{
    static main: Logger | null = null;
    private defaultStream: IStream = new StreamConsole();
    private formatter?: IFormatter = new FormatterFull();
    private customFormatter: { [level: string]: IFormatter } = {};
    private streams: IStream[] = [];
    constructor()
    {
        if (Logger.main == null)
            Logger.main = this;
        this.setFromatter = this.setFromatter.bind(this);
        this.setCustomFormatter = this.setCustomFormatter.bind(this);
        this.addStream = this.addStream.bind(this);
        this.log = this.log.bind(this);
        this.trace = this.trace.bind(this);
        this.verbose = this.verbose.bind(this);
        this.debug = this.debug.bind(this);
        this.info = this.info.bind(this);
        this.success = this.success.bind(this);
        this.warning = this.warning.bind(this);
        this.error = this.error.bind(this);
        this.critical = this.critical.bind(this);
        this.fatal = this.fatal.bind(this);
        this.onCatchError = this.onCatchError.bind(this);
        this.onCatchCritical = this.onCatchCritical.bind(this);
        this.onCatchFatal = this.onCatchFatal.bind(this);
        this.getErrorMessage = this.getErrorMessage.bind(this);
        this.getErrorStack = this.getErrorStack.bind(this);
        this.initUncought = this.initUncought.bind(this);
    }
    setFromatter(formatter: IFormatter): void
    {
        this.formatter = formatter;
    }
    setCustomFormatter(level: LogLevel, formatter: IFormatter): void
    {
        this.customFormatter[level] = formatter;
    }
    addStream(stream: IStream)
    {
        this.streams.push(stream);
    }
    log(level: LogLevel, ...messages: any[])
    {
        let log = new Log(level, ...messages);
        let formatted: { pre: string[], messages: string[], post: string[] } = { pre: [], messages: [], post: [] };
        let formatter = this.customFormatter[level.toString()] ?? this.formatter;
        if (formatter)
            formatted = formatter.format(log);
        if (this.streams.length == 0)
            this.defaultStream.write(log, formatted);
        else
            this.streams.map(s => s.write(log, formatted));
    }
    trace(...messages: any[])
    {
        this.log(LogLevel.Trace, ...messages);
    }
    verbose(...messages: any[])
    {
        this.log(LogLevel.Verbose, ...messages);
    }
    debug(...messages: any[])
    {
        this.log(LogLevel.Debug, ...messages);
    }
    info(...messages: any[])
    {
        this.log(LogLevel.Info, ...messages);
    }
    success(...messages: any[])
    {
        this.log(LogLevel.Success, ...messages);
    }
    warning(...messages: any[])
    {
        this.log(LogLevel.Warning, ...messages);
    }
    error(...messages: any[])
    {
        this.log(LogLevel.Error, ...messages);
    }
    critical(...messages: any[])
    {
        this.log(LogLevel.Critical, ...messages);
    }
    fatal(...messages: any[])
    {
        this.log(LogLevel.Fatal, ...messages);
    }
    onCatchError(error: Error | unknown)
    {
        this.error(this.getErrorMessage(error), this.getErrorStack(error));
    }
    onCatchCritical(error: Error | unknown)
    {
        this.critical(this.getErrorMessage(error), this.getErrorStack(error));
    }
    onCatchFatal(error: Error | unknown)
    {
        this.fatal(this.getErrorMessage(error), this.getErrorStack(error));
    }
    protected getErrorMessage(error: Error | unknown): string
    {
        if (error instanceof Error)
            return error.message;
        return error + "";
    }
    protected getErrorStack(error: Error | unknown): string
    {
        if (error instanceof Error)
            return error.stack ?? "";
        return error + "";
    }
    initUncought()
    {
    }
}